/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import { TableCell, TableRow, Tooltip } from "@mui/material";
import React from "react";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LockResetIcon from "@mui/icons-material/LockReset";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import StatusIcon from "../../../assets/svg/Status";
import Table from "../../../components/common/new/Table/Table";
import {
  PROXY_ROLE_MEMBER_SEAECH_TABLE_COL,
  ROLE_MEMBER_SEAECH_TABLE_COL,
} from "../../../contants/table/memberSearch";
import tableStyle from "../../../theme/styles/table";
import styles from "./style";
import Typography from "../../../components/common/new/Typography/Typography";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
    textAlign: "center",
  },
  small: {
    maxWidth: "6rem",
    textAlign: "center",
  },
  medium: {
    maxWidth: "10rem",
    textAlign: "center",
  },
};

const getRows = ({
  searchData,
  showStatusColumn,
  onEdit,
  onResetPassword,
  shouldShowProxyRolesColumn,
  onImpersonation,
}) =>
  searchData.map((memberInfo) => {
    const truncateText = (text, maxLength) =>
      text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    return (
      <TableRow style={tableStyle.tableRow}>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {memberInfo.memberId}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {memberInfo.fullName}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {memberInfo.divisionName}
          </Typography>
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {`${memberInfo.areaName || "-"}/ ${memberInfo.zoneName || "-"}/ ${
                memberInfo.regionName || "-"
              }/ ${memberInfo.chapterName || "-"}/ ${
                memberInfo.districtName || "-"
              }/ ${memberInfo.blockName || "-"}`}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <div style={styles.tableBox}>
            {memberInfo?.assignedRoles &&
            memberInfo.assignedRoles.length > 0 ? (
              <Typography style={styles.typoghrphyStyle}>
                {memberInfo?.assignedRoles?.map((roles) => (
                  <div
                    style={
                      roles === "areaSI" ||
                      roles === "zoneSI" ||
                      roles === "regionSI" ||
                      roles === "chapterSI" ||
                      roles === "districtSI"
                        ? {
                            ...styles.roleChips,
                            color: "#05445E",
                            backgroundColor: "#D4F1F4",
                          }
                        : roles === "helpDesk"
                        ? {
                            ...styles.roleChips,
                            color: "#741AAC",
                            backgroundColor: "#EAE7FA",
                          }
                        : roles === "nationalLeader"
                        ? {
                            ...styles.roleChips,
                            width: "120px",
                            color: "#C52FFC",
                            backgroundColor: "#F6EEF0",
                          }
                        : {
                            ...styles.roleChips,
                            color: "#C52FFC",
                            backgroundColor: "#F6EEF0",
                          }
                    }
                  >
                    <span title={roles}>{truncateText(roles, 13)}</span>
                  </div>
                ))}
              </Typography>
            ) : (
              <Typography style={styles.typoghrphyStyle}>-</Typography>
            )}
          </div>
        </TableCell>
        {shouldShowProxyRolesColumn && (
          <TableCell style={tabelCellWidth.medium}>
            <div style={styles.tableBox}>
              {memberInfo.proxyRoles && memberInfo.proxyRoles.length !== 0 ? (
                <Typography
                  style={{
                    ...styles.typoghrphyStyle,
                    ...styles.roleChips,
                    backgroundColor: "#D3D3D3",
                  }}
                >
                  DistrictSI
                </Typography>
              ) : (
                "-"
              )}
            </div>
          </TableCell>
        )}
        {showStatusColumn && (
          <TableCell style={tabelCellWidth.medium}>
            <div style={styles.tableBox}>
              <StatusIcon
                label={memberInfo.status}
                // width={memberInfo.status === "ACTIVE" ? "84px" : "120px"}
              />
            </div>
          </TableCell>
        )}

        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <div
            style={{
              ...styles.actionButtons,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Tooltip
              title={memberInfo.status === "ACTIVE" ? "Edit Roles" : null}
            >
              <ManageAccountsIcon
                style={
                  memberInfo.status === "DEACTIVATED"
                    ? {
                        ...styles.actionIcon,
                        marginTop: "4px",
                        opacity: 0.5,
                        cursor: "not-allowed",
                      }
                    : { ...styles.actionIcon, marginTop: "4px" }
                }
                onClick={() => {
                  if (memberInfo.status !== "DEACTIVATED") onEdit(memberInfo);
                }}
              />
            </Tooltip>
            <div>
              <Tooltip
                title={memberInfo.status === "ACTIVE" ? "Reset Password" : null}
              >
                <LockResetIcon
                  style={
                    memberInfo.status === "DEACTIVATED"
                      ? {
                          ...styles.actionIcon,
                          marginTop: "4px",
                          opacity: 0.5,
                          cursor: "not-allowed",
                        }
                      : { ...styles.actionIcon, marginTop: "4px" }
                  }
                  onClick={() => {
                    if (memberInfo.status !== "DEACTIVATED")
                      onResetPassword(memberInfo);
                  }}
                />
              </Tooltip>
            </div>
            <div>
              <Tooltip title="Impersonation">
                <SwitchAccountIcon
                  style={
                    memberInfo.status === "DEACTIVATED"
                      ? {
                          ...styles.actionIcon,
                          marginTop: "4px",
                          opacity: 0.5,
                          cursor: "not-allowed",
                        }
                      : { ...styles.actionIcon, marginTop: "4px" }
                  }
                  onClick={() => {
                    if (memberInfo.status !== "DEACTIVATED")
                      onImpersonation(memberInfo);
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </TableCell>
      </TableRow>
    );
  });

function MemberRoleTable({
  searchData,
  onSelectMemberForTransfer,
  onMemberStatusToggle,
  //   onSelectMember,
  onEdit,
  hasPermission,
  showStatusColumn,
  onResetPassword,
  onImpersonation,
}) {
  const shouldShowProxyRolesColumn = searchData.some(
    (memberInfo) => memberInfo.proxyRoles && memberInfo.proxyRoles.length > 0
  );

  console.log("shouldShowProxyRolesColumn", shouldShowProxyRolesColumn);

  const columns =
    shouldShowProxyRolesColumn === true
      ? PROXY_ROLE_MEMBER_SEAECH_TABLE_COL
      : showStatusColumn
      ? ROLE_MEMBER_SEAECH_TABLE_COL
      : ROLE_MEMBER_SEAECH_TABLE_COL.filter((c) => c.key !== "status");

  // if (shouldShowProxyRolesColumn) {
  //   const hasProxyRolesColumn = columns.some(
  //     (column) => column.key === "proxyRoles"
  //   );

  //   if (!hasProxyRolesColumn) {
  //     columns.push({
  //       key: "proxyRoles",
  //       displayName: "Proxy Roles",
  //       width: "8rem", // You can set an appropriate width
  //     });
  //   }
  // }

  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          onSelectMemberForTransfer,
          //   onSelectMember,
          onEdit,
          hasPermission,
          onMemberStatusToggle,
          showStatusColumn,
          onResetPassword,
          shouldShowProxyRolesColumn,
          onImpersonation,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "center",
        }}
      />
    </div>
  );
}

export default MemberRoleTable;
